import axios from 'axios';
const api = axios.create({ baseURL: "https://api.salescott.com" });
// const api = axios.create({ baseURL: "http://127.0.0.1:5000" });

export const endpoints = {
    login: (d) => api.post('/auth/login', d),
    register: (d) => api.post('/auth/register', d),
    savePage1: (d) => api.post('/campaign/save_page1', d),
    uploadCSV: (fd) => api.post('/campaign/upload_contacts', fd, { headers: {'Content-Type': 'multipart/form-data'} }),
    generate: (d) => api.post('/campaign/generate', d),
    selectVersion: (d) => api.post('/campaign/select_version', d),
    saveSchedule: (d) => api.post('/campaign/save_schedule', d),
    start: (d) => api.post('/campaign/start', d),
    getPerformance: (u, n) => api.get(`/tracker/performance?user_email=${u}&campaign_name=${n}`),
    editEmail: (d) => api.put('/tracker/edit_email_by_index', d),
    editCSV: (fd) => api.put('/tracker/edit_csv', fd, { headers: {'Content-Type': 'multipart/form-data'} }),
    get_campaigns: (u) => api.get(`/tracker/get_all_campaigns?user_email=${u}`),
    edit_campaign: (d) => api.put('/tracker/edit_campaign', d),
    get_campaign_details: (u, n) => api.get(`/tracker/get_campaign_details?user_email=${u}&campaign_name=${n}`),
    edit_schedule: (d) => api.put('/tracker/edit_schedule', d),
    updateAccount: (d) => api.put('/profile/update_account', d),
    updateMarketingCreds: (d) => api.put('/profile/update_marketing_credentials', d),
    triggerCall: (to) => api.post('/make-call', { to }, { headers: { 'Content-Type': 'application/json' } }),
};